import { ISelectOption } from 'components/forms/Selects'
import { REGION_ABBREVIATIONS } from 'constants/countriesStates'

export interface ICostControlConfig {
  id?: string
  pickupRegion: REGION_ABBREVIATIONS | string
  deliveryRegion: REGION_ABBREVIATIONS | string
  costStrategy: COST_STRATEGIES
  controlOption: CONTROL_OPTIONS
  ruleType: RULE_TYPES
  rangeStart?: string
  rangeEnd?: string
  isDrop: boolean
}

export interface ICostControlConfigState {
  error?: string
  fetching: boolean
  costControlConfigs: ICostControlConfig[]
  costControlConfig?: ICostControlConfig
  modalOpen: boolean
  deleteModalOpen: boolean
  configToDelete?: ICostControlConfig
  modalError?: string
  saving: boolean
}

export enum COST_STRATEGIES {
  TCM25 = 'TCM_25',
  TCM40 = 'TCM_40',
  TCM50 = 'TCM_50',
  TCM65 = 'TCM_65',
  TCM75 = 'TCM_75',
  DAT = 'DAT',
}

export enum CONTROL_OPTIONS {
  quoting = 'quoting',
  covering = 'covering',
  sbr = 'sbr',
}

export enum RULE_TYPES {
  lane = 'lane',
  baseline = 'baseline',
  outbound = 'outbound',
}

export interface IRegionOption extends ISelectOption<REGION_ABBREVIATIONS> {}

export interface IControlOption extends ISelectOption<CONTROL_OPTIONS> {}

export interface ICostStrategyOption extends ISelectOption<COST_STRATEGIES> {}

export interface IRuleTypeOption extends ISelectOption<RULE_TYPES> {}
